import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const ProprietaryRightsTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <>
      <SectionHeader title="Proprietary Rights" />
      <ol start={3}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            This Web Site is maintained by the Singapore Examinations and Assessment Board <br />
            (SEAB).
            <br />
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`The materials located on this Web Site including the information and software ` +
              `programs (the Contents), are protected by copyright, trademark and other forms of proprietary ` +
              `rights. All rights, title and interest in the Contents are owned by, licensed to or controlled by SEAB.`}
          </Typography>
        </li>
      </ol>
    </>
  );
};

export default ProprietaryRightsTermsOfUse;
